import uuidv4 from 'uuid/v4';

const createBookingClientRequestId = () => `qantas-hotels-ui-${uuidv4()}`;

export default createBookingClientRequestId;
